import './InstallButton.css';

import { useEffect, useState } from 'react';

const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const checkIfInstalled = () => {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    };

    if (checkIfInstalled()) {
      setIsInstalled(true);
      return;
    }

    const handleBeforeInstallPrompt = e => {
      e.preventDefault();
      setDeferredPrompt(e);
      console.log('beforeinstallprompt event captured');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      const result = await deferredPrompt.prompt();
      console.log('Install prompt result:', result);

      if (result.outcome === 'accepted') {
        setIsInstalled(true);
      }

      setDeferredPrompt(null);
    } else {
      const installInstructions = `
Install this app:

🔹 Chrome/Edge: Look for "Open in app" button in the address bar
🔹 Safari: Tap Share button → "Add to Home Screen"
🔹 Firefox: Menu → "Install this site as an app"

Or try these steps:
• Menu (⋮) → "Install app" or "Add to Home screen"
• Right-click page → "Install [app name]"
      `.trim();

      alert(installInstructions);
    }
  };

  if (isInstalled) {
    return null;
  }

  return (
    <button className="install-button" onClick={handleInstallClick} title="Install this app on your device">
      📱 Install
    </button>
  );
};

export default InstallButton;
